import { api } from "@/lib/api";
import {
  Guide,
  GuideDtoSchema,
  mapGuideFromDto,
  mapGuideToDto,
} from "@/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getGuideQueryOptions, getGuidesQueryOptions } from "./get.hooks";

export function useUpdateGuide(opts?: {
  onSuccess?: (guide: Guide) => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async (guide: Guide) => {
      const dto = mapGuideToDto(guide);
      const result = await api.put("/api/guides", dto, GuideDtoSchema);
      return mapGuideFromDto(result);
    },
    onSuccess: (guide) => {
      queryClient.setQueryData(getGuidesQueryOptions.queryKey, (old) =>
        old?.map((g) => (g.id === guide.id ? guide : g)),
      );
      queryClient.setQueryData(
        getGuideQueryOptions(guide.id).queryKey,
        () => guide,
      );
      toast({
        title: "toast.guideUpdated",
        variant: "success",
      });
      opts?.onSuccess?.(guide);
    },
    onError: () => {
      toast({
        title: "toast.updateGuideError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
